import React, { useMemo, useRef } from 'react'
import PropTypes from 'prop-types'

// Components
import Button from 'ui/Button'

// Styles
import './FileDropZone.scss'

export const FileDropZone = ({
  size,
  style,
  label,
  accept,
  multiple,
  disabled,
  onChange,
}) => {
  const inputFileRef = useRef()
  const classList = useMemo(() => {
    const classes = ['dragger', size]
    return classes.join(' ')
  }, [size])

  const onDrop = (e) => {
    e.preventDefault()

    const files = multiple
      ? e.dataTransfer.files
      : Array.from(e.dataTransfer.files).filter((_, index) => index < 1)

    onChange(files)
  }

  const onInput = (e) => {
    e.preventDefault()
    onChange(e.target.files)
    inputFileRef.current.value = ''
  }

  return (
    <div className="x-drag-drop-zone">
      <div
        className={classList}
        onDrop={onDrop}
        onDragOver={(e) => e.preventDefault()}
        onClick={() => inputFileRef.current.click()}
        style={style}
      >
        <input
          ref={inputFileRef}
          type="file"
          hidden={true}
          disabled={disabled}
          multiple={multiple}
          accept={accept}
          onChange={onInput}
        />
        <p className="help-text">Drop your file/s here to upload or</p>
        <Button variant="outline-primary">{label}</Button>
      </div>
    </div>
  )
}

// Props
FileDropZone.propTypes = {
  size: PropTypes.oneOf(['sm', 'md']),
  style: PropTypes.object,
  label: PropTypes.string,
  accept: PropTypes.string,
  multiple: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
}

FileDropZone.defaultProps = {
  size: 'md',
  style: {},
  label: 'Select file from computer',
  accept: null,
  multiple: false,
  disabled: false,
  onChange: () => {},
}

export default FileDropZone
